// extracted by css-extract-rspack-plugin
export default {"copyButton":"FormTextInput-module__copyButton___SGIUn"};